export enum ChatRoomTypes {
  learnership,
  internship,
}
